import type { KeyboardEvent } from 'react';

// Commit an inline-editable field on Enter by blurring it (its onBlur handler does the commit),
// and prevent the keypress from bubbling to an enclosing form submit.
export const blurOnEnter = (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    (e.target as HTMLInputElement).blur();
  }
};
